import toNumber from 'lodash/toNumber';
import { object, number } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

export default ({ amount }) => {
    const { REQUIRED_TEXT, getMaxValueText, getMinValueText } =
        getValidationTexts();
    const formattedAmount = toNumber(amount.toFixed(4));

    return object().shape({
        hitch: number().when('isKam', {
            is: false,
            then: (schema) =>
                schema
                    .typeError(REQUIRED_TEXT)
                    .required(REQUIRED_TEXT)
                    .min(0, getMinValueText(0))
                    .max(formattedAmount, getMaxValueText(formattedAmount)),
            otherwise: (schema) => schema.notRequired(),
        }),
        term: number()
            .typeError(REQUIRED_TEXT)
            .required(REQUIRED_TEXT)
            .min(1, getMinValueText(1)),
    });
};
